module.exports = __webpack_public_path__ + "static/shareFanWater1BG-c6bc6f6b0b62294c9f84d3c6bf5b8f83.png";